import { Box, CardActions, CardContent, Collapse, styled, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { Chart } from "../../common/Chart/Chart";
import { unixToString } from "../../utils/time";
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IDatedValues, IFutureExtended } from "../PairSpreadItem/PairSpreadItem";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

interface IFutures {
    futNear: IFutureExtended,
    futFar: IFutureExtended,
}

export const CustomTabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ pt: 1, ml: -2, mr: -2 }}>
                {children}
          </Box>
        )}
      </div>
    );
}

export const GraphSpreads: React.FC<IFutures> = (futures: IFutures) => {
    const [value, setValue] = useState(0);
    const [expanded, setExpanded] = useState(false);

    const a11yProps = (index: number) => {
        return {
          id: `simple-tab-${index}`,
          'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const getChart = (preadValues: IDatedValues[]) => {
        return <Chart
            data={ preadValues }
            width={ 1000 }
            height={ 500 }
            nameAxisX='x'
            nameAxisY='y'
            xFormatter={ unixToString }
            yFormatter={ (n) => `${n.toFixed(1)}` }
            yFormatterLabel={ (n) => `${n.toFixed(2)}%` }
            fitAxisY={ true } />
    }

    const ExpandMore = styled((props: any) => {
        const { expand, ...other } = props;
            return <IconButton {...other} />;
        })(({ theme, expand }) => ({
            transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
            marginLeft: 'auto',
            marginTop: 0,
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shortest,
            }),
    }));

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    return (
        <>
            <CardActions disableSpacing className='expandCont'>
                <span className='expandTitle'>{ 'График спреда' }</span>
                <ExpandMore
                    expand={ expanded }
                    onClick={ handleExpandClick }
                    aria-expanded={ expanded }
                    aria-label="Подробнее"
                >
                    <ExpandMoreIcon />
                </ExpandMore>
            </CardActions>

            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: -2 }}>
                        <Tabs value={ value } onChange={ handleChange } aria-label="basic tabs example">
                            <Tab label={ futures.futNear.shortName } {...a11yProps(0)} />
                            <Tab label={ futures.futFar.shortName } {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={ value } index={0}>
                        { getChart(futures.futNear.spreadValues) }
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        { getChart(futures.futFar.spreadValues) }
                    </CustomTabPanel>
                </CardContent>
            </Collapse>
        </>
    );
}